<style scoped>
.dropdown-menu::after,
.dropdown-menu::before {
  content: none;
}
.modal-table {
  margin-bottom: 0;
}
</style>

<template>
  <td>
    <div
      v-if="!model.deleted_at"
      ref="dropdown"
      class="dropdown"
      :class="{ show: show, dropup: index > 10, dropleft: true }"
    >
      <button
        @click="show = !show"
        class="btn btn-secondary dropdown-toggle"
        type="button"
      >
        Aktionen
      </button>
      <div class="dropdown-menu" :class="{ show: show }">
        <div @click="$modal.show(showModalAndHideMenu())" class="dropdown-item">
          Verlauf
        </div>
        <div @click="edit" class="dropdown-item">Bearbeiten</div>
        <div @click="remove" class="dropdown-item">Löschen</div>
      </div>
    </div>

    <modal
      width="80%"
      height="auto"
      :pivot-y="0.1"
      :adaptive="true"
      resizable
      scrollable
      :name="showPostbackHistoryModalName"
    >
      <v-table
        class="modal-table"
        url="/api/v1/postbackActivity"
        :filter="[
          {
            name: 'where',
            attributes: {
              postback_id: this.model.id
            }
          }
        ]"
        :attributes="[
          {
            attribute: 'user_id',
            name: 'User-ID'
          },
          {
            attribute: 'user_email',
            name: 'User-Email'
          },
          {
            attribute: 'amount',
            name: 'Geldbetrag (in € cent)'
          },
          {
            attribute: 'ip',
            name: 'IP'
          },
          {
            attribute: 'created_at',
            name: 'Erstellt am',
            type: 'DateTimeCell'
          },
          {
            attribute: 'postback_data',
            name: 'Link',
            type: 'PostbackDataCell',
            sortable: false
          }
        ]"
      >
        <div slot="title">
          <h4>Verlauf der getriggerten Events des Postbacks</h4>
        </div>
      </v-table>
    </modal>
  </td>
</template>

<script>
import { catchOutsideClicks } from "@/js/bodyClick.js";

export default {
  props: ["model", "tableId", "index"],
  data() {
    return {
      show: false,
      deleting: false
    };
  },
  mounted() {
    catchOutsideClicks(this.$refs.dropdown, () => {
      this.show = false;
    });
  },
  methods: {
    edit() {
      if (this.deleting) {
        return;
      }

      this.$router.push({ path: new URL(this.model.update_page_url).pathname });
    },
    remove() {
      if (this.deleting) {
        return;
      }

      let confirmed = confirm("Sicher?");
      if (!confirmed) {
        return;
      }

      this.deleting = true;

      this.$store
        .dispatch("postback/delete", {
          url: this.model.delete_url,
          id: this.model.id
        })
        .then(() => {
          this.$emit("table-update", { count: true });
        })
        .finally(() => {
          this.deleting = false;
        });
    },
    showModalAndHideMenu() {
      this.show = false;
      return this.showPostbackHistoryModalName;
    }
  },
  computed: {
    showPostbackHistoryModalName() {
      return `postback-${this.model.id}-history`;
    }
  }
};
</script>
